// components/list/List.tsx
import { CatUploadInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: CatUploadInterface) => void
  showDetails: (el: CatUploadInterface) => void
  list: CatUploadInterface[] | []
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list || !Array.isArray(list) || (!list.length && !loading) ? (
        <div className={classes.Message}>Нет импортов</div>
      ) : (
        list.map((el: CatUploadInterface) => (
          <Item showDetails={showDetails} el={el} startEdit={startEdit} key={el.id} />
        ))
      )}
    </div>
  )
}
